import { render, staticRenderFns } from "./audienceTable.vue?vue&type=template&id=57184385&scoped=true"
import script from "./audienceTable.vue?vue&type=script&lang=js"
export * from "./audienceTable.vue?vue&type=script&lang=js"
import style0 from "./audienceTable.vue?vue&type=style&index=0&id=57184385&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57184385",
  null
  
)

export default component.exports